export default {
  placeholder: 'Wählen Sie ein Schlagwort aus',
  createTag: 'Ereignis-Schlagwort erstellen',
};
